import { IClientConfigs } from '~/shared';
import { createSlice } from '../wrappers';

type NumberPlatesRegion =
	IClientConfigs['vehicleNumberPlates']['regions'][number];

interface IIndexedNumberPlateRegion extends NumberPlatesRegion {
	index: number;
}

const initialState = {
	regionList: [] as IIndexedNumberPlateRegion[],
	selectedRegion: null as IIndexedNumberPlateRegion | null,
	filteredRegionList: [] as IIndexedNumberPlateRegion[],
};

const regionSelectionSlice = createSlice({
	name: 'regionSelection',
	initialState,
	reducers: {
		setCurrentIndex: (state, action) => {
			const regionIndex = action.payload;
			state.selectedRegion =
				state.filteredRegionList.find(
					(region) => region.index === regionIndex,
				) || null;
		},
		// resetCurrentIndex: (state) => {
		// 	state.selectedRegion = null;
		// },
		setPreviousIndex: (state) => {
			if (state.selectedRegion === null) {
				return;
			}

			const currentFilteredIndex = state.filteredRegionList.findIndex(
				(region) => region.index === state.selectedRegion?.index,
			);

			const prevFilteredIndex =
				currentFilteredIndex > 0
					? currentFilteredIndex - 1
					: currentFilteredIndex;

			state.selectedRegion = state.filteredRegionList[prevFilteredIndex];
		},
		setNextIndex: (state) => {
			if (state.selectedRegion === null) {
				return;
			}

			const currentFilteredIndex = state.filteredRegionList.findIndex(
				(region) => region.index === state.selectedRegion?.index,
			);

			const filteredLength = state.filteredRegionList.length;
			const nextFilteredIndex =
				currentFilteredIndex < filteredLength - 1
					? currentFilteredIndex + 1
					: currentFilteredIndex;

			state.selectedRegion = state.filteredRegionList[nextFilteredIndex];
		},
		setFilteredRegionList: (state, action) => {
			state.filteredRegionList = action.payload;
		},
	},
});

export const {
	setCurrentIndex,
	setPreviousIndex,
	setNextIndex,
	setFilteredRegionList,
} = regionSelectionSlice.actions;

export default regionSelectionSlice.reducer;
